export default __webpack_public_path__ + "static/media/location_preview_sizzling_sands.a816d597.svg";